<template>
  <div class="custom-input">
    <input
      :id="props.inputId"
      type="text"
      :class="props.inputClass"
      :data-scope="scope"
      :placeholder="placeholder"
      ref="inputRef" />
    <base-icon
      v-if="withClear"
      class="input-clear"
      icon-name="cross"
      width="14"
      height="14"
      viewBox="0 0 28.945 28.945"
      @click="clearModelValue">
      <cross-icon></cross-icon>
    </base-icon>
  </div>
</template>

<script setup lang="ts">
  import hotkeys from "hotkeys-js";

  import { defineModel, defineProps, onMounted, onUnmounted, ref, watch } from "vue";
  import { BaseIcon, CrossIcon } from "@/components/icons";
  const props = withDefaults(
    defineProps<{
      scope: string;
      inputClass?: string | null;
      inputId?: string | null;
      withClear?: boolean;
      placeholder?: string;
    }>(),
    {
      inputClass: null,
      inputId: null,
      withClear: false,
      placeholder: "Enter the key"
    }
  );

  const modelValue = defineModel<string[] | string | null>();

  const inputRef = ref<HTMLInputElement>();

  watch(modelValue, () => {
    updateInput();
  });

  onMounted(() => {
    hotkeys("*", { scope: props.scope, element: inputRef.value }, callback);
    updateInput();
  });

  onUnmounted(() => {
    hotkeys.unbind("*", props.scope, callback);
  });

  const clearModelValue = () => {
    modelValue.value = null;
  };

  const updateInput = () => {
    let values = modelValue.value ?? "";
    if (Array.isArray(values)) {
      values = values.join(" + ");
    }
    inputRef.value?.setAttribute("value", values);
  };

  const callback = (e: KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const pressedKeyString = hotkeys.getPressedKeyString();
    const ignoredKeys = ["del", "backspace", "tab"];

    if (ignoredKeys.some((key) => hotkeys.getPressedKeyString().includes(key))) {
      return;
    }

    let value = pressedKeyString.map((item) => item.toUpperCase()).join(" + ");

    inputRef.value?.setAttribute("value", value);
    modelValue.value = pressedKeyString || [];
    return false;
  };
</script>
<style lang="scss" scoped>
  .custom-hot-key-input {
    input {
      caret-color: transparent;
      user-select: none;
    }
  }
</style>
